import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	textDefaultTextLabel: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.text.text-default-text-label',
		defaultMessage: 'Default text',
		description:
			'Label above input that informs user the input is setting default value for text field.',
	},
	textDefaultValuePlaceholder: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.text.text-default-value-placeholder',
		defaultMessage: 'Enter default text',
		description: 'Placeholder that shows when short text field default value is empty.',
	},
	textDefaultValueDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.text.text-default-value-disabled-tooltip',
		defaultMessage: 'You can’t change this field’s default text',
		description: 'Tooltip shown when the default text field is disabled and cannot be edited',
	},
	defaultValueTooLongErrorText: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.text.default-value-too-long-error-text',
		defaultMessage: "Text fields can't have more than {MAX_ALLOWED_TEXT_LENGTH} characters.",
		description: 'Validation error shown to the user if too long text is typed in the input.',
	},
});
